import {
  Time,
  Color,
  toCamelCaseObject, toSnakeCaseObject
} from 'utils';
import {
  Status
} from './Status';

export interface StatusLog {
  companyId?: number;
  factoryId?: number;
  equipmentId?: number;
  timeFrom: Date;
  timeTo: Date;
  detections?: any[];
  updatedAt?: Date;
  statusId?: string;
  statusName?: string;
  statusColorRgb?: Color;
  statusIsCountTarget?: boolean;
  statusIsEnabled?: boolean;
}

export function parseStatusLog(a: any): StatusLog {
  let obj = toCamelCaseObject(a);
  obj.timeFrom = Time.dateFromStrAsUtc(obj.timeFrom);
  obj.timeTo = Time.dateFromStrAsUtc(obj.timeTo);
  if (obj.statusColorRgb) {
    obj.statusColorRgb = new Color(obj.statusColorRgb as number);
  }
  if (obj.updatedAt) {
    obj.updatedAt = Time.dateFromStrAsUtc(obj.updatedAt);
  }
  return obj as StatusLog;
}
export function parseStatusLogs(arr: any[]): StatusLog[] {
  return arr?.map(a => parseStatusLog(a));
}

export function applyStatusProps(a: StatusLog, statuses: Status[]): StatusLog {
  const status = statuses.find(status => status.id === a.statusId);
  if (status) {
    a.statusName = status.name;
    a.statusColorRgb = status.colorRgb;
    a.statusIsCountTarget = status.isCountTarget;
    a.statusIsEnabled = status.isEnabled;
  }
  return a;
}
